import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader } from "lucide-react";

export default function QRLogin() {
  const { usn } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Scanning QR...");

  useEffect(() => {
    if (!usn) {
      setStatus("Invalid QR code");
      return;
    }

    const fetchStudent = async () => {
      try {
        const response = await fetch(
          `https://hostel-laundry-api.onrender.com/api/admin/students/${usn}`
        );

        const data = await response.json();

        if (!data || !data.usn) {
          setStatus("No student found for this QR");
          return;
        }

        // Save student data
        localStorage.setItem("student", JSON.stringify(data));

        setStatus("Login successful! Redirecting...");
        setTimeout(() => navigate("/student-dashboard"), 1500);

      } catch (err) {
        console.error(err);
        setStatus("Server error. Cannot login.");
      }
    };

    fetchStudent();
  }, [usn, navigate]);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="bg-white border border-neutral-200 rounded-2xl shadow-sm p-10 text-center max-w-sm w-full">
        <Loader className="w-8 h-8 text-neutral-900 animate-spin mx-auto mb-4" />
        <h1 className="text-xl font-bold text-neutral-900 mb-2">QR Login</h1>
        <p className="text-sm text-neutral-500">{status}</p>
      </div>
    </div>
  );
}
